import type { EditorThemeClasses } from 'lexical';

export const lexicalTheme: EditorThemeClasses = {
  root: 'lexical-root',
  text: {
    bold: 'lexical-bold',
    italic: 'lexical-italic',
    underline: 'lexical-underline',
    strikethrough: 'lexical-strikethrough',
    code: 'lexical-code-inline',
    underlineStrikethrough: 'lexical-underline-strikethrough',
  },
  heading: {
    h1: 'lexical-h1',
    h2: 'lexical-h2',
    h3: 'lexical-h3',
  },
  list: {
    ul: 'lexical-ul',
    ol: 'lexical-ol',
    listitem: 'lexical-li',
    nested: {
      listitem: 'lexical-nested-li',
    },
  },
  link: 'lexical-link',
  quote: 'lexical-quote',
  code: 'lexical-code-block',
  paragraph: 'lexical-paragraph',
};
